import { showLoading } from '../store/ui/actions'
import { store } from '../store';
export class LoadingSwither {

    static HideLoading = (): boolean => {
        store.dispatch(showLoading(false) as any)
        return false
    };

    static ShowLoading = (): boolean => {
        store.dispatch(showLoading(true) as any)
        return true
    };

}